<template>
  <a-sub-menu :key="menuInfo.id" v-bind="$attrs" v-if="!!menuInfo.show">
    <template #title>
      <span>
        <span>{{ menuInfo.describe }}</span>
      </span>
    </template>
    <template v-for="item in menuInfo.children" :key="item.id">
      <template v-if="!item.children">
        <a-menu-item :key="item.id" v-if="!!item.show">
          <router-link :to="{ name: item?.name }">
            <span>{{ item.describe }}</span>
          </router-link>
        </a-menu-item>
      </template>
      <template v-else>
        <sub-menu :menu-info="item" :key="item.id" />
      </template>
    </template>
  </a-sub-menu>
</template>

<script>
export default {
  props: {
    menuInfo: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>